/**
 * @generated SignedSource<<f7b194225e73be3b4afeb3d53f83091e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CateringSidebar_cateringOption$data = {
  readonly " $fragmentSpreads": FragmentRefs<"EntitySidebar_entity">;
  readonly " $fragmentType": "CateringSidebar_cateringOption";
};
export type CateringSidebar_cateringOption$key = {
  readonly " $data"?: CateringSidebar_cateringOption$data;
  readonly " $fragmentSpreads": FragmentRefs<"CateringSidebar_cateringOption">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CateringSidebar_cateringOption",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EntitySidebar_entity"
    }
  ],
  "type": "CateringOption",
  "abstractKey": null
};

(node as any).hash = "800be9b7cac6e249347271e588b9680c";

export default node;
